function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 257.16 113.22"
}, props), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "4.5",
  d: "M218.59 42.78l35.65 20.26-194.57.2-57-28.47h142.56"
}), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "4.5",
  d: "M185.34 63.09l-125.67.13-57-28.47h144s38-.5 36-32.5c19 10.33 37.33 22 37.33 22s9 33.34-34.66 38.84z"
}), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "4.5",
  d: "M254 74.95H59.67l-57-28.67"
}), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "4.5",
  d: "M253.58 87.69H59.25l-57-28.67"
}), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "4.5",
  d: "M254.08 100.42H59.75l-57-28.67"
}), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "5",
  d: "M2.66 35.22v48l56.26 27.5.62-47.5m195.12 0v47.5H59.16m-41-69h126.51S191 41.51 189.19 7"
}), React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "5",
  d: "M47.16 55.72h126.51s45.5 1 39.12-35.11"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M151.67 48.38c0 1.75-6.86 3.17-15.33 3.17S121 50.13 121 48.38s6.87-3.16 15.34-3.16 15.33 1.41 15.33 3.16z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M135.28 50.06c-2.07 0-3.5-.26-3.88-.76l2.62-.11a4.71 4.71 0 0 0 2.42.29c1.2 0 1.95-.22 1.94-.46s-.45-.29-1.55-.3h-2.07c-1.72 0-3.1-.21-3.12-.75s1.37-.93 3.5-1.09v-.49l2.24-.1v.51c1.86 0 3 .31 3.35.73l-2.51.11a4.5 4.5 0 0 0-2.25-.27c-1.12 0-1.83.23-1.82.45s.47.26 1.36.29h2.2c2 0 3.18.29 3.2.77s-1.37.93-3.4 1.1v.52l-2.24.1z"
})));